import React from 'react';
import PropTypes from 'prop-types';
import i18nMessages from '../../../constants/messages/pt-BR';

class Chip extends React.Component {
  chipRef = null;

  handleDeleteIconClick = event => {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();
    const { onDelete } = this.props;
    if (onDelete) {
      onDelete(event);
    }
  };

  render() {
    const {
      classes,
      className: classNameProp,
      component: Component,
      deleteIcon: deleteIconProp,
      label,
      onClick,
      onDelete,
      onKeyDown,
      iconStyle,
      labelStyle,
      tabIndex: tabIndexProp,
      ...other
    } = this.props;

    let deleteIcon = null;
    if (onDelete) {
      deleteIcon =
        deleteIconProp && React.isValidElement(deleteIconProp) ? (
          React.cloneElement(deleteIconProp, {
            onClick: this.handleDeleteIconClick,
          })
        ) : (
          <a
            className={iconStyle}
            href="javascript:void(0)"
            onClick={this.handleDeleteIconClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.handleDeleteIconClick(e);
              }
            }}
            aria-label="Remover"
          >
            {i18nMessages.andtimes}
          </a>
        );
    }

    let tabIndex = tabIndexProp;

    if (!tabIndex) {
      tabIndex = onClick || onDelete ? 0 : -1;
    }

    return (
      <Component
        className={classNameProp}
        role="button"
        tabIndex={tabIndex}
        onClick={onClick}
        ref={node => {
          this.chipRef = node;
        }}
        {...other}
      >
        <span className={labelStyle}>{label}</span>
        {deleteIcon}
      </Component>
    );
  }
}

Chip.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element.isRequired,
  /**
   * The content of the label.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Chip = ({prop = val, component = 'div', className = '', label = <span>label</span>, onClick = () => null, onDelete = () => null, onKeyDown = () => null, tabIndex = '' }) =>
export default Chip;
